import {get, post} from '@/utils/http'


/**
 * 获取用户信息
 * @param deviceId {String}
 * @returns {Promise<ResultDTO<DoumiClientConfig>>}
 */
async function getDoumiClientConfig(deviceId) {
    return await get('/doumi/config/get?deviceId=' + encodeURIComponent(deviceId))
}

/**
 * 注册用户
 * @param config {DoumiClientConfig}
 * @param deviceId {String}
 * @returns {Promise<ResultDTO<>>}
 */
async function doSetDoumiClientConfig({config,deviceId}){
    return await post("/doumi/config/set?deviceId=" + encodeURIComponent(deviceId), config);
}

export default {
    getDoumiClientConfig,doSetDoumiClientConfig
}
